import { downloadXlsx } from '../../common/downloadExcel.js';
import {
    saveFilters,
    loadFilters,
    saveSort,
    loadSort,
    getType
} from './helpers.js'

export default {
    data: () => ({
        namespace: null,
        // set a namespace to remember search/filters and sort; persistSession keeps them per tab (sessionStorage)
        // instead of forever (localStorage), persistSkip lists searchArgs keys that must not be restored
        persistSession: false,
        persistSkip: [],
        stateRestored: false,
        rows: [],
        search: '',
        currentSortDir: 'asc',
        currentSort: '',
    }),
    computed: {
        filteredRows() {
            const rows = this.rows;
            const searchArgs = this.search.trim().toLowerCase().split(',');
            const headers = Object.keys(this.headers);
            
            return rows.filter(row => {
                if (this.search.trim().length === 0) return true;
                
                for (let key of headers) {
                    let value = row[key]
                    // convert numbers to strings
                    if (isFinite(value)) {
                        value = ''+value
                    }

                    if (typeof value !== 'string') {
                        continue;
                    }

                    for (let search of searchArgs) {
                        if (search.trim().length === 0) {
                            continue;
                        }
                        if (value.toLowerCase().includes(search.trim())) {
                            return true;
                        }
                    }
                }

                return false;
            })
        },
        sortedRows() {
            const rows = this.filteredRows;
            const currentSortDir = this.currentSortDir;
            const currentSort = this.currentSort;

            return rows.sort((a, b) => {
                const modifier = currentSortDir === 'desc' ? -1 : 1;
                
                if(!a[currentSort] && !b[currentSort])
                    return 0;
                else if(!b[currentSort])
                    return 1 * modifier;
                else if(!a[currentSort])
                    return -1 * modifier;
                else if (a[currentSort] < b[currentSort])
                    return -1 * modifier;
                else if (a[currentSort] > b[currentSort])
                    return 1 * modifier;
                
                return 0;
            });
        },
    },
    watch: {
        search(val) {
            if (this.namespace) {
                saveFilters(this.namespace, val, this.stateStore())
            }            
        },
        currentSort() { this.saveSortState() },
        currentSortDir() { this.saveSortState() },
    },
    methods: {
        stateStore() {
            return this.persistSession ? sessionStorage : localStorage;
        },
        saveSortState() {
            if (this.namespace && this.currentSort) {
                saveSort(this.namespace, { currentSort: this.currentSort, currentSortDir: this.currentSortDir }, this.stateStore())
            }
        },
        setSort(key, forceSort = null) {
            if (forceSort) {
                this.currentSortDir = forceSort;
            } else if (key === this.currentSort) {
                this.currentSortDir = this.currentSortDir === 'asc' ? 'desc' : 'asc';
            }
            this.currentSort = key;
        },
        downloadXlsx(fileName = null, mapRows = (row) => row) {
            const rows = this.filteredRows.map(mapRows)
            const headers = {}

            for (let key of Object.keys(this.headers)) {
                headers[key] = { title: this.headers[key] }
            }

            downloadXlsx({
                rows,
                headers,
                fileName
            })
        },
    },
    beforeMount() {
        if (!this.namespace) return;
        
        const search = loadFilters(this.namespace, null, this.stateStore())

        if (getType(search) === String) {
            this.search = search
        }

        const sort = loadSort(this.namespace, this.stateStore())

        if (sort?.currentSort) {
            this.currentSort = sort.currentSort
            this.currentSortDir = sort.currentSortDir === 'desc' ? 'desc' : 'asc'
            this.stateRestored = true
        }
    },
}